import React, { Component } from "react";
import {
  Table, Form, Popup, Icon, Grid, Checkbox,
  Modal, Header, Button
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

const ipRegex = new RegExp("^[0-2][0-9.]*$");
const macRegex = new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$");

const UtilsInstance = new Utils();

class Ports extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isPortsFilterToggleChecked: false,
      isFirstFilterRetrieve: true,
      isModalOpen: false,
      turnText: Strings.TURN_ON,
      isColumnClicked: false
    };
  }

  handleSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order devices by ip descending
    if (clickedColumn === "ip" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        }),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by ip descending
    else if (clickedColumn === "ip" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num2 - num1;
        }),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by name ascending
    else if (clickedColumn === "name" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "name",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by name descending
    else if (clickedColumn === "name" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "name",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by mac ascending
    else if (clickedColumn === "mac" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "mac",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by mac descending
    else if (clickedColumn === "mac" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "mac",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
  }

  // Creates a list with entries that match the IP passed on the form
  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with entries that match the name passed on the form
  handleNameSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].name != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].name.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleMacAddressSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].mac != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].mac.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    Filters the page list showing only the devices that match the
    ip or name the user has typed
  */
  handleSubmit = () => {
    if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    else if (this.state.formInput !== "" && macRegex.test(this.state.formInput)) {
      this.handleMacAddressSearch();
    }
    else if (this.state.formInput !== "" ) {
      this.handleNameSearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user
    // didn't sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {
      // Only get the filter state when this variable is true
      if (this.state.isFirstFilterRetrieve) {
        let promissesArray = [];

        // Retrieve devices list
        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "ethernetLink", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        // Retrieve the intelligent filter state
        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "filterPortsState", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        let resolvedPromisses = await Promise.all(promissesArray);

        let devices = resolvedPromisses[0].sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        });

        let portStateFilter = resolvedPromisses[1];

        this.setState({
          devices: devices,
          originalDevices: devices,
          isPortsFilterToggleChecked: portStateFilter.filter,
          isFirstFilterRetrieve: false
        });
      }
      else {
        // Retrieve devices list
        fetch(Constants.REQUEST_IP_ADDRESS + "ethernetLink", { mode: "cors" })
          .then(res => res.json())
          .then((data) => {
            // Sort the devices by IP
            let devicesCopy = JSON.parse(JSON.stringify(data));

            devicesCopy = devicesCopy.sort((a, b) => {
              const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
              const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
              return num1 - num2;
            });
            this.setState({
              devices: devicesCopy,
              originalDevices: devicesCopy
            });
          });
      }
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_DIAGNOSTIC;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  getLinkStatusCell = (link_status) => {
    if (link_status === "Active") {
      return (
        <Table.Cell verticalAlign="middle" style={activeLinkStatusCell}>
          {Strings.ACTIVE}
        </Table.Cell>
      );
    }
    else if (link_status === "Inactive") {
      return (
        <Table.Cell verticalAlign="middle" style={unknownLinkStatusCell}>
          {Strings.INACTIVE}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell verticalAlign="middle" style={unknownLinkStatusCell}>
          {Strings.UNKNOWN}
        </Table.Cell>
      );
    }
  }

  getSpeedCell = (interface_speed) => {
    if (interface_speed !== "") {
      return <Table.Cell verticalAlign="middle">{interface_speed}{Strings.MEGABITS_PER_SECOND_SUFFIX}</Table.Cell>;
    }
    else {
      return <Table.Cell verticalAlign="middle"></Table.Cell>;
    }
  }

  /*  
    ------------------------------------------------------------
    ------------------------- Filtros --------------------------
    ------------------------------------------------------------  
  */

  showModal = () => this.setState({ isModalOpen: true })

  closeModal = () => this.setState({ isModalOpen: false })

  handleModalCancelClick = () => {
    this.closeModal();
  }

  handleModalOkClick = () => {
    this.alterPortsFilter();
  }

  toggleIntelligentFilterCheckbox = () => {
    if (this.state.isPortsFilterToggleChecked) {
      this.setState({
        turnText: Strings.TURN_OFF,
        isModalOpen: true
      });
    }
    else {
      this.setState({
        turnText: Strings.TURN_ON,
        isModalOpen: true
      });
    }
  }

  alterPortsFilter = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "filterPorts_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ filter: !this.state.isPortsFilterToggleChecked })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        this.setState({
          isPortsFilterToggleChecked: !this.state.isPortsFilterToggleChecked,
          isFirstFilterRetrieve: true, // let the filter be refreshed once more
        }, () => {
          // refresh the data right after turning the filter on/off
          this.retrieveData();
        });
      })
      .catch((error) => {
        if (this.state.isPortsFilterToggleChecked) {
          alert(Strings.PORTS_FILTER_TURN_ON_FAILURE + "\n" + Strings.REASON_DP + error);
        }
        else {
          alert(Strings.PORTS_FILTER_TURN_OFF_FAILURE + "\n" + Strings.REASON_DP + error);
        }
      })
      .finally(() => {
        this.closeModal();
      });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount = () => {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate = () => {
    this.adjustTableMaxHeight();
  }

  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const topologyDevices = this.state.devices.map(device => (
      <React.Fragment key={device.mac}>
        <Table.Row style={mainTableRowStyle}>
          <Table.Cell width="3" verticalAlign="middle">{device.ip}</Table.Cell>
          <Table.Cell width="3" verticalAlign="middle">{device.mac}</Table.Cell>
          <Table.Cell width="3" verticalAlign="middle">{device.name}</Table.Cell>
          <Table.Cell width="16" colSpan="7" />
        </Table.Row>
        {
          device.instances.map(instance => (
            // eslint-disable-next-line react/jsx-key
            <Table.Row>
              <Table.Cell colSpan="3" verticalAlign="middle">{instance.interface_label}</Table.Cell>
              <Table.Cell verticalAlign="middle">{instance.interface_type}</Table.Cell>
              <Table.Cell verticalAlign="middle">{instance.duplex}</Table.Cell>
              {this.getSpeedCell(instance.interface_speed)}
              <Table.Cell verticalAlign="middle">{instance.negotiation_status}</Table.Cell>
              <Table.Cell verticalAlign="middle">{instance.local_hardware_fault}</Table.Cell>
              <Table.Cell verticalAlign="middle">{instance.interface_state}</Table.Cell>
              {this.getLinkStatusCell(instance.link_status)}
            </Table.Row>
          ))
        }
      </React.Fragment>
    ));

    return (
      <div style={screenStyle}>
        <Grid columns={3} verticalAlign="middle">

          <Grid.Column width={4} />

          <Grid.Column width={8}>
            <Form onSubmit={this.handleSubmit} >
              <Form.Input
                id="inputform"
                placeholder={Strings.PORTS_INPUT_TEXT_PLACEHOLDER}
                icon="search"
                name="formInput"
                value={filter}
                onChange={this.handleChange} />
            </Form>
          </Grid.Column>

          <Grid.Column width={4} >
            <Checkbox
              //style={checkboxStyle}
              fitted
              toggle
              label={
                <label>
                  {Strings.PORTS_FILTER_LABEL}
                  <Popup
                    wide
                    position='bottom right'
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>{Strings.PORTS_FILTER_POPUP_1}</p>
                      <p>{Strings.PORTS_FILTER_POPUP_2}</p>
                    </Popup.Content>
                  </Popup>
                </label>
              }
              onChange={this.toggleIntelligentFilterCheckbox}
              checked={this.state.isPortsFilterToggleChecked} />

          </Grid.Column>

        </Grid>


        <Table id="table-header" style={headerMarginStyle} sortable compact stackable fixed structured celled textAlign="center">
          <Table.Header>
            <Table.Row>

              <Table.HeaderCell width="3" rowSpan="2"
                sorted={column === "ip" ? direction : null}
                onClick={this.handleSort("ip")}>
                {Strings.IP}
              </Table.HeaderCell>

              <Table.HeaderCell width="3" rowSpan="2"
                sorted={column === "mac" ? direction : null}
                onClick={this.handleSort("mac")}>
                {Strings.MAC}
              </Table.HeaderCell>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell width="3" rowSpan="2"
                    sorted={column === "name" ? direction : null}
                    onClick={this.handleSort("name")}>
                    {Strings.PRODUCT_NAME_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.PRODUCT_NAME_2}<br />
                    {Strings.PRODUCT_NAME_3}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.PRODUCT_NAME_POPUP_1}</p>
                  <p>{Strings.PRODUCT_NAME_POPUP_2}</p>
                  <p>{Strings.PRODUCT_NAME_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Table.HeaderCell width="16" colSpan="7" disabled>{Strings.PORTS}</Table.HeaderCell>
            </Table.Row>
            <Table.Row>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.INTERFACE_TYPE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.INTERFACE_TYPE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.INTERFACE_TYPE_POPUP_1}</p>
                  <p>{Strings.INTERFACE_TYPE_POPUP_2}</p>
                  <p>{Strings.INTERFACE_TYPE_POPUP_3}</p>
                  <p>{Strings.INTERFACE_TYPE_POPUP_4}</p>
                  <p>{Strings.INTERFACE_TYPE_POPUP_5}</p>
                  <p>{Strings.INTERFACE_TYPE_POPUP_6}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.DUPLEX_MODE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.DUPLEX_MODE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.DUPLEX_MODE_POPUP_1}</p>
                  <p>{Strings.DUPLEX_MODE_POPUP_2}</p>
                  <p>{Strings.DUPLEX_MODE_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.INTERFACE_SPEED_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.INTERFACE_SPEED_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.INTERFACE_SPEED_POPUP_1}</p>
                  <p>{Strings.INTERFACE_SPEED_POPUP_2}</p>
                  <p>{Strings.INTERFACE_SPEED_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.NEGOTIATION_STATUS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.NEGOTIATION_STATUS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.NEGOTIATION_STATUS_POPUP_1}</p>
                  <p>{Strings.NEGOTIATION_STATUS_POPUP_2}</p>
                  <p>{Strings.NEGOTIATION_STATUS_POPUP_3}</p>
                  <p>{Strings.NEGOTIATION_STATUS_POPUP_4}</p>
                  <p>{Strings.NEGOTIATION_STATUS_POPUP_5}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.HARDWARE_FAULT_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.HARDWARE_FAULT_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.LOCAL_HARDWARE_FAULT_POPUP_1}</p>
                  <p>{Strings.LOCAL_HARDWARE_FAULT_POPUP_2}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.INTERFACE_STATUS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.INTERFACE_STATUS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.INTERFACE_STATUS_POPUP_1}</p>
                  <p>{Strings.INTERFACE_STATUS_POPUP_2}</p>
                  <p>{Strings.INTERFACE_STATUS_POPUP_3}</p>
                  <p>{Strings.INTERFACE_STATUS_POPUP_4}</p>
                  <p>{Strings.INTERFACE_STATUS_POPUP_5}</p>
                  <p>{Strings.INTERFACE_STATUS_POPUP_6}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom right' hoverable pinned wide
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.LINK_STATUS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.LINK_STATUS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.LINK_STATUS_POPUP_1}</p>
                  <p>{Strings.LINK_STATUS_POPUP_2}</p>
                  <p>{Strings.LINK_STATUS_POPUP_3}</p>
                </Popup.Content>
              </Popup>

            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" style={tableBorderStyle} compact stackable fixed structured celled textAlign="center">
            <Table.Body>
              {topologyDevices}
            </Table.Body>
          </Table>
        </div>

        <Modal style={modalStyle} centered open={this.state.isModalOpen} onClose={this.closeModal} size='small'>
          <Header icon='warning sign' content={Strings.ARE_YOU_SURE_YOU_WANT + this.state.turnText + Strings.THE_PORTS_FILTER} />
          <Modal.Content>
            <p>{Strings.PORTS_FILTER_POPUP_1}</p>
            <p>{Strings.PORTS_FILTER_POPUP_2}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={this.handleModalCancelClick}>
              <Icon name='remove' />{Strings.NO}
            </Button>
            <Button color='green' onClick={this.handleModalOkClick}>
              <Icon name='checkmark' />{Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll",
};

const tableBorderStyle = {
  borderCollapse: "separate"
};

const headerMarginStyle = {
  marginTop: "16px",
  marginBottom: "8px",
  width: "99%",
  borderCollapse: "separate"
};

const mainTableRowStyle = {
  backgroundColor: "#BDBDBD"
};

const activeLinkStatusCell = {
  backgroundColor: "lime",
  color: "black"
};

const unknownLinkStatusCell = {
  backgroundColor: "#dcdcdc",
  color: "black"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const modalStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30vh",
  height: "275px"
};

export default withRouter(Ports);
